import { useState, useEffect, useContext } from 'react';
import AuthContext from 'context/AuthContext';

type CatalogReturnValue = {
  response: { [key: string] : any };
  loading: boolean;
  error?: Error;
}

const makeEndpoint = (type : string, id : number) => {
  switch (type) {
    case 'track':
    default:
      return `catalog/tracks/${id}/`;
  }
}

export default function useCatalog(type, id) : CatalogReturnValue {
  const auth = useContext(AuthContext);
  const [response, setResponse] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    if (response && window.BeatportEmbed?.player?.current?.playlist?.length === 0) {
      if (type === 'track') {
        window.BeatportEmbed?.player?.current?.playlist?.addTrack(response);
      }
    }
  }, [response, window.BeatportEmbed?.player?.current?.playlist]);

  useEffect(() => {
    if (auth.access_token && type && id) {
      fetch(`https://api.beatport.com/v4/${makeEndpoint(type, id)}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.access_token}`
        }
      })
        .then(response => {
          if (response.status === 404) {
            throw new Error(`Sorry, we couldn't find that ${type}.`);
          } else if (response.status === 403) {
            throw new Error(`Sorry, this ${type} is not available.`);
          } else if (response.status > 400) {
            throw new Error('Sorry, something wen\'t wrong.');
          }

          return response;
        })
        .then(response => response.json())
        .then(response => {
          setResponse(response)
          setLoading(false);
        })
        .catch(e => {
          setError(e);
          setLoading(false);
        });
    } else {
      setLoading(false);
      setResponse(null);
    }
  }, [type, id, auth.access_token]);

  return {
    response,
    loading,
    error,
  }
}